module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-list"
  }, [_c('h2', [_vm._v("顧客詳細")]), _vm._v(" "), _c('form', [_c('md-input-container', [_c('label', [_vm._v("ID")]), _vm._v(" "), _c('md-input', {
    staticClass: "s6",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.selected_row.customer_id),
      callback: function($$v) {
        _vm.selected_row.customer_id = $$v
      },
      expression: "selected_row.customer_id"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("氏名")]), _vm._v(" "), _c('md-input', {
    on: {
      "change": _vm.name_changed
    },
    model: {
      value: (_vm.selected_row.name),
      callback: function($$v) {
        _vm.selected_row.name = $$v
      },
      expression: "selected_row.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("〒")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "postal_cd"
    },
    on: {
      "change": _vm.postal_cd_changed
    },
    model: {
      value: (_vm.selected_row.postal_cd),
      callback: function($$v) {
        _vm.selected_row.postal_cd = $$v
      },
      expression: "selected_row.postal_cd"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("都道府県")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "prefecture"
    },
    model: {
      value: (_vm.selected_row.prefecture),
      callback: function($$v) {
        _vm.selected_row.prefecture = $$v
      },
      expression: "selected_row.prefecture"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("市区町村")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "city"
    },
    model: {
      value: (_vm.selected_row.city),
      callback: function($$v) {
        _vm.selected_row.city = $$v
      },
      expression: "selected_row.city"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("住所")]), _vm._v(" "), _c('md-input', {
    ref: "address1",
    attrs: {
      "id": "address1"
    },
    model: {
      value: (_vm.selected_row.address1),
      callback: function($$v) {
        _vm.selected_row.address1 = $$v
      },
      expression: "selected_row.address1"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("電話番号")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "phone"
    },
    model: {
      value: (_vm.selected_row.phone),
      callback: function($$v) {
        _vm.selected_row.phone = $$v
      },
      expression: "selected_row.phone"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("備考")]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: (_vm.selected_row.memo),
      callback: function($$v) {
        _vm.selected_row.memo = $$v
      },
      expression: "selected_row.memo"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2850d3d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerDetail.vue
// module id = 207
// module chunks = 1